exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".snapshot-history [for='compare-account'] {\n  margin-left: 5px;\n}\n", ""]);

